import { createModalStore } from '@/shared/lib/modal';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

import type { TrialPlan } from './PLANS';

type TrialPaywallState = {
  title?: string;
  allowedPlanNames?: null | TrialPlan['name'][];
  preSelectedPlanName?: null | TrialPlan['name'];
  pricingEntryPoint?: PricingEntryPoint;
};

const initialState: TrialPaywallState = {
  title: undefined,
  allowedPlanNames: null,
  preSelectedPlanName: null,
  pricingEntryPoint: 'unattributed_paywall',
};

export const useTrialPaywallModalStore = createModalStore<TrialPaywallState>(initialState);
